import { useState } from 'react';
import { useNavigate } from '@tanstack/react-router';
import { RoleForm } from '@/components/admin/RoleForm';
import { useCreateRole } from '@/lib/hooks/useRoles';
import type { RoleFormSubmitInput } from '@/lib/types/roles.types';

export function RoleCreate() {
  const navigate = useNavigate();
  const createRoleMutation = useCreateRole();
  const [submitError, setSubmitError] = useState<string | null>(null);

  const handleSubmit = async (input: RoleFormSubmitInput) => {
    setSubmitError(null);

    try {
      const role = await createRoleMutation.mutateAsync(input);
      navigate({
        to: '/admin/manage-roles/$roleId',
        params: { roleId: role.id },
      });
    } catch (error) {
      setSubmitError(
        error instanceof Error ? error.message : 'Failed to save role.'
      );
    }
  };

  return (
    <RoleForm
      role={null}
      isSubmitting={createRoleMutation.isPending}
      submitError={submitError}
      onSubmit={handleSubmit}
      onCancel={() => navigate({ to: '/admin/manage-roles' })}
    />
  );
}
